function detectBrowserAndDevice() {

	/* Alias for document.body.classList.add() */
	function addCls( cls ) {
		document.body.classList.add( cls );
	}

	const ua = window.navigator.userAgent;

	const isIos = !! ua.match( /iPad/i ) || !! ua.match( /iPhone/i );
	const isWebkit = !! ua.match( /WebKit/i );
	const isIosSafari =
		isIos && isWebkit && ! ua.match( /CriOS/i ) && ! ua.match( /OPiOS/i );

	let isChrome = window.chrome;
	const isExplorer = ua.indexOf( 'MSIE' ) > -1;
	const isFirefox = ua.indexOf( 'Firefox' ) > -1;
	let isSafari = ua.indexOf( 'Safari' ) > -1;
	const isEdge = ua.indexOf( 'Edge' ) > -1;
	const isOpera = ua.toLowerCase().indexOf( 'op' ) > -1;
	const isAppleDevice =
		['iPad', 'iPhone', 'iPod'].indexOf( navigator.platform ) >= 0;
	const isNativeAndroid =
		ua.indexOf( 'Mozilla/5.0' ) > -1 &&
		ua.indexOf( 'Android ' ) > -1 &&
		ua.indexOf( 'AppleWebKit' ) > -1 &&
		ua.indexOf( 'Version' ) > -1;

	const isIe10 = navigator.appVersion.indexOf( 'MSIE 10' ) !== -1;
	const isIe11 = ua.indexOf( 'Trident' ) !== -1 && ua.indexOf( 'rv:11' ) !== -1;

	if ( isChrome && isSafari ) {
		isSafari = false;
	}
	if ( isChrome && isOpera ) {
		isChrome = false;
	}

	/* IE10 does not support classList so we use className */
	if ( isIe10 ) {
		document.documentElement.className += 'ie-10';
	}

	/* Prevent IE10 from erroring by exiting early */
	if ( ! isIe10 ) {
		if ( isAppleDevice ) {
			addCls( 'apple-device' );
		}

		if ( isNativeAndroid && ! isChrome ) {
			addCls( 'native-android-browser' );
		}

		if ( isEdge ) {
			addCls( 'edge' );
		} else if ( isIe11 ) {
			addCls( 'ie-11-or-newer' );
		} else if ( isChrome ) {
			addCls( 'chrome' );
		} else if ( isFirefox ) {
			addCls( 'firefox' );
		} else if ( isSafari ) {
			addCls( 'safari' );
		} else if ( isOpera ) {
			addCls( 'opera' );
		} else if ( isExplorer ) {
			addCls( 'ie' );
		}
	}
}

detectBrowserAndDevice();
